import React from "react";
import PropTypes from "prop-types";
import moment from 'moment';
import * as zoom from 'chartjs-plugin-zoom'


import Chart from "../../utils/chart";
const axios = require('axios').default;
var tooltipsLabel_all = [];
var tooltipsLabel_top = [];
class Botness extends React.Component {
    constructor(props) {
        super(props);
        
        this.maxCnt = 1000;
        this.tweetData = null;
        this.canvasRef = React.createRef();
    }

    componentDidMount() {
        this.intializeChart();
    }

    intializeChart = () => {
        axios.get(`data/topic${this.props.topicId}_botness.json`) // data/topicsData1.json
            .then(response => {
                this.tweetData = response.data.chartData.datasets;
                this.buildChart();
                
                tooltipsLabel_all = {...this.tweetData[0].data};
                tooltipsLabel_top = {...this.tweetData[1].data};
                // console.log(this.tweetData);
                
            }).catch((err)=>{
                console.log(err.status);
            })

            
    }

    buildChart = () => {
        const chartOptions = {
            ...{
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    labels: {
                        fontColor: '#f4f4f4'
                    }
                },
                scales: {
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            fontColor: '#f4f4f4',
                            labelString: 'CAP (Complete Automation Probability) indicates the likelihood that a Twitter account is fully automated.'
                        },
                        ticks: {
                            stepSize: 43200,
                            fontColor: '#f4f4f4',
                            // precision: 3600,
                            callback: (value) => {
                                return moment.unix(value).format("YYYY-MM-DD HH:mm:ss")
                                }
                            }
                        }]
                        ,
                    yAxes: [
                    
                        {
                            "id": "left",
                            "position": "left",
                            type: 'linear',
                            autoSkip: false,
                            ticks: {
                                precision:1,
                                min: 0, //minimum tick
                                callback: function (value) {
                                    return (value * 100).toFixed(0) + '%'; // convert it to percentage
                                  },
                                fontColor: '#f4f4f4',
                                
                            },
                            
                            scaleLabel: {
                                display: true,
                                labelString: 'CAP Score',
                                fontColor: '#f4f4f4',
                            },
                            
                        }

                        
                        
                    ]
                },
                hover: {
                    mode: "nearest",
                    intersect: false
                },
                tooltips: {
                    custom: false,
                    mode: "nearest",
                    intersect: false,
                    callbacks: {
                        title: function(tooltipItem, data) {
                            // console.log(tooltipsLabel_top);
                            // console.log(tooltipItem[0].datasetIndex);
                            // if(tooltipItem[0].datasetIndex = 1)
                            var name = tooltipItem[0].datasetIndex === 1 ? 
                            tooltipsLabel_all[tooltipItem[0].index].user_name : 
                            tooltipsLabel_top[tooltipItem[0].index].user_name;
                            // console.log(tooltipItem);
                            var time = moment.unix(tooltipItem[0].xLabel).format("YYYY-MM-DD HH:mm:ss");
                            return name + "\n" + time;
                            // "\n" + "Time: "+tooltipItem[0].label;
                            // return tooltipItem[0].datasetIndex === 1 ? 
                                // tooltipsLabel_all[tooltipItem[0].index].user_name : tooltipsLabel_top[tooltipItem[0].index].user_name;
                          },

                        label: function(tooltipItem, data) {
                            // console.log(tooltipItem);
                            return ('CAP: ' +(tooltipItem.yLabel*100).toFixed(1) +'%');
                            
                            // return moment.unix(tooltipItem.xLabel).format("YYYY-MM-DD HH:mm:ss");
                        },
                        // afterLabel: function(tooltipItem, data) {

                        //     return ('CAP: ' +(tooltipItem.yLabel*100).toFixed(1) +'%');
                                    
                        // },
                    }
                },
                // {
                //     custom: false,
                //     mode: "nearest",
                //     intersect: false,
                //     callbacks: {
                //         title: function(tooltipItem, data) {
                //             return tooltipsLabel2[tooltipItem[0].index].user_name;
                //           },

                //         label: function(tooltipItem, data) {
                            
                //             return moment.unix(tooltipItem.xLabel).format("YYYY-MM-DD HH:mm:ss");
                //         },
                //         afterLabel: function(tooltipItem, data) {

                //             return ('CAP: ' +(tooltipItem.yLabel*100).toFixed(1) +'%');
                                    
                //         },
                //     }
                // }
            
                
                // plugins: {
                //     zoom: {
                //         pan: {
                //             enabled: true,
        
                //             mode: 'x',
                //             rangeMin: {
                //                 x: null,
                //                 y: 0
                //             },
                //             rangeMax: {
                //                 x: null,
                //                 y: null
                //             },
                //             speed: 20,

                //             threshold: 10,

                        
                //         },

                //         zoom: {
                            
                //             enabled: true,
        
                //             mode: 'x',
                //             speed: 0.1,
                //             rangeMin: {
                //                 x: null,
                //                 y: 0
                //             },

                //             threshold: 2,

                //             sensitivity: 3,
		
                //         }
                //     }
                // }
            },
            ...this.props.chartOptions
        };

        this.chart = new Chart(this.canvasRef.current, {
            type: 'scatter',
            data: {
                datasets: [
                    {
                        "backgroundColor": "#F7941D",
                        "borderColor": "#F7941D",
                        pointRadius: 5,
                        pointHoverRadius: 10,
                        label: 'Click To Hide/Show Top Influencers',
                        labels: {
                            // This more specific font property overrides the global property
                            fontColor: '#FFFFFF'
                        },
                        data: this.tweetData[1].data
                    },
                    {
                    label: 'Click To Hide/Show All Users',
                    "backgroundColor": "#FFFFFF",
                    "borderColor": "#FFFFFF",
                    pointRadius: 2,
                    pointHoverRadius: 4,
                    data: this.tweetData[0].data
                }]
            },
            options: chartOptions
        });

        
        this.chart.render();

    }




    render() {
        return (
            <div style={{height: "300px"}}>
                <canvas
                    height="70"
                    ref={this.canvasRef}
                    style={{ maxWidth: "100% !important" }}
                />
            </div>
        );
    }
}

Botness.propTypes = {
    /**
     * The component's title.
     */
    title: PropTypes.string,
    /**
     * The chart dataset.
     */
    chartData: PropTypes.object,
    /**
     * The Chart.js options.
     */
    chartOptions: PropTypes.object
};

Botness.defaultProps = {
    title: "Popular Fake News on Twitter",
};

export default Botness;






















